export default __webpack_public_path__ + "static/media/logo-new.0827b8e5.svg";